module.exports = __webpack_public_path__ + "img/3-quad.67ff07b4.png";